import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import { trackPromise } from 'react-promise-tracker';
import { withSnackbar } from 'react-simple-snackbar';

class ProfileInfo extends Component{
    static contextType = AuthContext;
    state = {
        data:{}
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
            fetch(ApiBaseUrl + "/consumer/profile",
                {
                    method: 'GET',
                    headers:
                        {
                            "Authorization": "Bearer "+this.context.token
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if(!result.success)
                            this.props.openSnackbar(result.message)
                        else
                            this.setState({
                                data: result.data
                            });
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
    }

    logoutHandler = (event) => {
        event.preventDefault();
        localStorage.clear();
        window.location.replace(process.env.PUBLIC_URL+'/')
    }

    render(){
        return(
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-4 col-lg-4 px--xs-0">
                            <div className="sidebar-profile-outer-full">
                                <div className="sidebar-profile-outer" style={{display:"flex",alignItems: "center"}}>
                        <div className="sidebar-profile-image">
                            <img src={this.state.data.image} alt={this.state.data.name}/>
                        </div>
                        <div className="sidebar-profile-info">
                            <Link to={`${process.env.PUBLIC_URL}/profile`}>{this.state.data.name}</Link>
                            <Link to={`${process.env.PUBLIC_URL}/profile`} className="mail-text">{this.state.data.email}</Link>
                            <Link to={`${process.env.PUBLIC_URL}/edit-profile`} className="mail-text"><i className="fa fa-pencil icon-fa-sidebar" aria-hidden="true"></i> Edit Profile</Link>
                        </div>
                                </div>
                    </div>
                        </div>
                        <div className="col-md-8 col-lg-8 px--xs-0">
                            <div className="outer-sidebar-top custom-sidebar">
                        <ul className="list-unstyled sidebar-list-menu-outer row">
                            <li><Link to={`${process.env.PUBLIC_URL}/allday/shared-deals`} className="scrollpart"><i className="fa fa-share-alt icon-fa-sidebar" aria-hidden="true"></i>
                                Associate Host Shared deals</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/cart/purchased`} className="scrollpart"><i className="fa fa-cart-plus icon-fa-sidebar" aria-hidden="true"></i>
                                My purchased cart deals</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/favorites`} className="scrollpart"><i className="fa fa-heart-o icon-fa-sidebar" aria-hidden="true"></i>My favorite deals</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/oneday/my-purchased-deals`} className="scrollpart"><i className="fa-ticket fa icon-fa-sidebar" aria-hidden="true"></i>
                                My purchased group deals</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/allday/my-purchased-deals`} className="scrollpart"><i className="fa-ticket fa icon-fa-sidebar" aria-hidden="true"></i>My purchased per person deals</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/following`} className="scrollpart"><i className="fa-compass fa icon-fa-sidebar" aria-hidden="true"></i>Following</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/cart`} className="scrollpart"><i className="fa-cart-arrow-down fa icon-fa-sidebar" aria-hidden="true"></i>My cart deals</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/refer`} className="scrollpart"><i className="fa-check-circle-o fa icon-fa-sidebar" aria-hidden="true"></i>Refer us to a friend</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/reviews/pending`} className="scrollpart"><i className="fa-star-o fa icon-fa-sidebar" aria-hidden="true"></i>Review & Rating</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/settings`} className="scrollpart"><i className="fa-cogs fa icon-fa-sidebar" aria-hidden="true"></i>Settings</Link></li>
                            <li><Link to={`${process.env.PUBLIC_URL}/help`} className="scrollpart"><i className="fa-life-ring fa icon-fa-sidebar" aria-hidden="true"></i>Help / Contact Us</Link></li>
                            <li><a href={`${process.env.PUBLIC_URL}/`}  onClick={this.logoutHandler} className="scrollpart"><i className="fa-sign-out fa icon-fa-sidebar" aria-hidden="true"></i>Log Out</a></li>
                        </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withSnackbar(ProfileInfo,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});